import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

import TabsHeader from './TabsHeader';
import TabsNavigation from './TabsNavigation';
import { getContentStyle } from '../../services/styleUtils/contentStyleUtils';
import { useTheme } from '@mui/material/styles';
import { themeColor } from '../../services/styleUtils/colorUtils';
import {
  headingColor,
  normalizeHeadingLevel,
} from '../../services/styleUtils/headingStyleUtils';
import { getTextColorClass } from '../../services/generalUtils';

const HeroCarouselMain = ({ fields }) => {
  const { backgroundImage, useGradient, tabList } = fields;
  const theme = useTheme();

  const hasTabs = Array.isArray(tabList) && tabList.length > 0;

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [title, setTitle] = useState(
    hasTabs ? tabList[0]?.fields?.title || '' : '',
  );
  const [description, setDescription] = useState(
    hasTabs ? tabList[0]?.fields?.description || '' : '',
  );

  const [titleStyle, setTitleStyle] = useState(() => ({
    level: normalizeHeadingLevel(fields.titleStyle?.fields?.level),
    color: getTextColorClass(
      fields.titleStyle?.fields?.color
        ? headingColor(theme, fields.titleStyle?.fields?.color)
        : '#F4AA00',
    ),
    alignment: fields.titleStyle?.fields?.alignment || 'left',
  }));
  const [descriptionStyle, setDescriptionStyle] = useState(() =>
    getContentStyle(theme, fields?.descriptionStyle?.fields || {}),
  );
  const [backgroundColor, setBackgroundColor] = useState(() =>
    fields?.backgroundStyle?.fields?.color
      ? themeColor(theme, fields?.backgroundStyle?.fields?.color)
      : theme.palette.blue.main,
  );
  const [selectedIconBarColor, setSelectedIconBarColor] = useState(() =>
    fields?.selectedIconBarColor?.fields?.color
      ? themeColor(theme, fields?.selectedIconBarColor?.fields?.color)
      : '#B7BF10',
  );

  useEffect(() => {
    if (hasTabs) {
      setTitle(tabList[selectedIndex]?.fields?.title || '');
      setDescription(tabList[selectedIndex]?.fields?.description || '');
    } else {
      setTitle('');
      setDescription('');
    }
    setTitleStyle({
      level: normalizeHeadingLevel(fields.titleStyle?.fields?.level),
      color: getTextColorClass(
        fields.titleStyle?.fields?.color
          ? headingColor(theme, fields.titleStyle?.fields?.color)
          : '#FFF',
      ),
      alignment: fields.titleStyle?.fields?.alignment || 'left',
    });
    setDescriptionStyle(
      getContentStyle(theme, fields?.descriptionStyle?.fields || {}),
    );
    setBackgroundColor(
      fields?.backgroundStyle?.fields?.color
        ? themeColor(theme, fields?.backgroundStyle?.fields?.color)
        : theme.palette.blue.main,
    );
    setSelectedIconBarColor(
      fields?.selectedIconBarColor?.fields?.color
        ? themeColor(theme, fields?.selectedIconBarColor?.fields?.color)
        : '#B7BF10',
    );
  }, [selectedIndex, tabList, fields, theme, hasTabs]);

  if (!hasTabs) return null;

  return (
    <StyledTabsSection data-testid="header-wrapper">
      <TabsHeader
        title={title}
        description={description}
        backgroundImage={backgroundImage}
        useGradient={
          useGradient != null
            ? String(useGradient).toLowerCase() === 'true'
            : false
        }
        backgroundColor={backgroundColor}
        titleStyle={titleStyle}
        descriptionStyle={descriptionStyle}
      />
      <TabsNavigation
        tabs={tabList}
        selectedIndex={selectedIndex}
        onSelect={setSelectedIndex}
        selectedIconBarColor={selectedIconBarColor}
      />
    </StyledTabsSection>
  );
};

const StyledTabsSection = styled('div')(() => ({
  width: 'auto',
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: { sm: '540px', md: '768px', lg: '1180px', xl: '1180px' },
  marginTop: '20px',
  marginBottom: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
}));

export default HeroCarouselMain;
